import CategoryYourCoursesIcon from 'src/assets/icons/CategoryYourCoursesIcon';
import Certificate2Icon from 'src/assets/icons/Certificate2Icon';
import EnrollIcon from 'src/assets/icons/EnrollIcon';
import FileIcon from 'src/assets/icons/FileIcon';
import CategoryMarketingIcon from 'src/assets/icons/CategoryMarketingIcon';
import {
  UserCertificatesRoute,
  UserCourseBundlesRoute,
  UserCoursesRoute,
  UserMaterialsRoute,
  UserProfileRoute,
} from 'src/user/routes';
import { FC } from 'react';
import { IconProps } from 'src/lib/IconBox';

export interface UserProfileMenuItem {
  id: string;
  title: string;
  code: string;
  icon: FC<IconProps>;
  isSpecialCategory: boolean;
  mobileTitle: string;
  slug: string;
  url: string;
}

export const userProfileMenuItems: UserProfileMenuItem[] = [
  {
    id: UserCoursesRoute,
    mobileTitle: 'Mój<br />rozwój',
    title: 'Mój rozwój',
    icon: CategoryYourCoursesIcon,
    url: UserCoursesRoute,
    code: 'my-progress',
    isSpecialCategory: false,
    slug: 'moj-rozwoj',
  },
  {
    id: UserCourseBundlesRoute,
    mobileTitle: 'Kursy',
    title: 'Kursy',
    icon: CategoryMarketingIcon,
    url: UserCourseBundlesRoute,
    code: 'course-bundles',
    isSpecialCategory: false,
    slug: 'kursy',
  },
  {
    id: UserCertificatesRoute,
    mobileTitle: 'Certyfikaty',
    title: 'Certyfikaty',
    icon: Certificate2Icon,
    url: UserCertificatesRoute,
    code: 'certificates',
    isSpecialCategory: false,
    slug: 'certyfikaty',
  },
  {
    id: UserMaterialsRoute,
    mobileTitle: 'Materiały szkoleniowe',
    title: 'Materiały szkoleniowe',
    icon: FileIcon,
    url: UserMaterialsRoute,
    code: 'materials',
    isSpecialCategory: false,
    slug: 'materialy-szkoleniowe',
  },
  {
    id: UserProfileRoute,
    mobileTitle: 'Dane',
    title: 'Dane ',
    icon: EnrollIcon,
    url: UserProfileRoute,
    code: 'user-profile',
    isSpecialCategory: false,
    slug: 'dane',
  },
];
